<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-tipotalhao') {
            next({ name: 'agro-tipotalhao-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-tipotalhao') {
            this.$router.push({ name: 'agro-tipotalhao-list' });
        }
    },
};
</script>
